module.exports = __webpack_public_path__ + "img/no_scd.439acbaf.svg";